import type Embed from 'quill/blots/embed';
import type { Blot } from '../types';

const isSelectableInlineEmbed = (blot: Blot | null): blot is Embed =>
  blot?.statics?.blotName === 'mention' ||
  blot?.statics?.blotName === 'search-facet';

export default isSelectableInlineEmbed;
